define([
    "dojo/_base/declare",
    "csi/heading/Boolean"
], function(declare,BooleanRen) {

    return declare(BooleanRen, {
        canCopy: function(/*Context*/ctxCopy, /*Heading*/h) {
            // summary: enable drag-fill
            return true;
        }
    });
});